export default function notAgreementTerms(terms) {
  var optional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return terms.filter(function (term) {
    var _rev$agreement;

    if (!optional && !term.required) return false;
    var rev = term === null || term === void 0 ? void 0 : term.current_revision;
    if (!(rev !== null && rev !== void 0 && rev.agreement)) return true;
    if ((rev === null || rev === void 0 ? void 0 : (_rev$agreement = rev.agreement) === null || _rev$agreement === void 0 ? void 0 : _rev$agreement.term_revision_number) != (rev === null || rev === void 0 ? void 0 : rev.number)) return true;
  });
}